import React from 'react';
import { Link, useI18next } from 'gatsby-plugin-react-i18next';
import useLanguage from '../../../../hooks/useLanguage';
import useMedia from '../../../../hooks/useMedia';

const Languages = ({ closeMenu, open, activeHeader }) => {
  const { languages, originalPath } = useI18next();

  const [show, setShow] = React.useState(false);
  const langToggle = useLanguage;

  const isMedium = useMedia('(max-width: 991.98px) and (min-width: 767.98px)');
  const isSmall = useMedia('(max-width: 767.98px)');

  const topVal = isMedium ? 'auto' : isSmall ? 'auto' : '80px';

  return (
    <div
      className={
        activeHeader ? 'languages-wrapper is-scroll' : 'languages-wrapper'
      }
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      role="presentation"
    >
      <div className="languages-current__wrapper">
        <span
          className={!show ? 'languages-current' : 'languages-current is-show'}
        >
          {langToggle('Укр', 'Рус')}
        </span>
      </div>
      <div
        className={
          !show ? 'languages-all__overflow' : 'languages-all__overflow is-show'
        }
        style={{ top: activeHeader ? topVal : ' ' }}
      >
        <ul className={!show ? 'languages-all' : 'languages-all is-show'}>
          {languages.map((lng) => (
            <li
              key={lng}
              className={
                open ? 'languages-all__item is-open' : 'languages-all__item'
              }
            >
              <Link
                className={
                  !show
                    ? 'languages-all__item-link'
                    : 'languages-all__item-link is-show'
                }
                to={originalPath}
                language={lng}
                onClick={closeMenu}
              >
                {lng === 'ua' ? 'Укр' : 'Рус'}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Languages;
